<template>
  <div>
    <van-popup 
      v-model="show"
      title="Select Area"

      closeable
      round
      position="bottom"
      :style="{ height: '70%', margin:'10px auto auto auto' }"
      @close="close"
    >
    <!-- <van-icon size="30" :color="durum[item.durum].color" :name="durum[item.durum].icon" style="margin:10px">
    <span style="font-size:18px; margin:10px">{{durum[item.durum].text}}</span>

    </van-icon>

    <van-collapse v-model="activeNames" accordion >

      <van-collapse-item :title="$helper.ilkharfBuyuk(item.isim)" name='0' icon="shop-o">
        <van-cell title="Kod :" :value="item.kod"/>
        <van-cell title="Barkod :" :value="item.barkod"/>
        <van-cell title="Marka :" :value="$helper.ilkharfBuyuk(item.marka)"/>
        <van-cell title="Grup :" :value="$helper.ilkharfBuyuk(item.anagrup)"/>
        <van-cell title="Açıklama :" :value="$helper.ilkharfBuyuk(item.aciklama1)"/>
      </van-collapse-item>

      <van-collapse-item @click="depo()" :title="'Eldeki Miktar: '+item.miktar+' '+$helper.ilkharfBuyuk(item.birim)" name='1' icon="shop-o">
          <van-cell v-for="(post,index) in depolar" :key="index" :title="$helper.ilkharfBuyuk(post.dep_adi)" :value="post.miktar+' '+$helper.ilkharfBuyuk(item.birim)"/>
      </van-collapse-item>
      <van-collapse-item :title="'Net Fiyat: '+$helper.parabirimi(item.fiyat.maliyet,' TL')" name='2' icon="shop-o">
          <van-cell title="Liste Fiyatı" :value="$helper.parabirimi(item.fiyat.liste,' TL')"/>
          <van-cell title="KDV siz" :value="$helper.parabirimi(item.fiyat.kdvsiz,' TL')"/>
          <van-cell title="Kampanya" :value="$helper.parabirimi(item.fiyat.kampanyali,' TL')"/>
          <van-cell title="Net Fiyat" :value="$helper.parabirimi(item.fiyat.maliyet,' TL')"/>
      </van-collapse-item>  
      <van-collapse-item :title="'Ambalaj Kodu: '+$helper.ilkharfBuyuk(item.ambalaj)" name='3' icon="shop-o"> </van-collapse-item>          

    </van-collapse> -->
    <van-notice-bar :text="item.isim" left-icon="volume-o" />
    <van-row style="background: #f2f2f2; margin-top:20px">
      <van-col span="3" style="text-align: center;background:inherit;padding:15px 0;">
        <van-icon name="orders-o" size="44" :badge="varmi" />       
      </van-col>

      <van-col span="10">
        <van-field style="background: #f8f8f8; font-size:32px; text-align:center"  v-model="fiyat.maliyet" value="0" right type="number" placeholder="Fiyat"></van-field>        
      </van-col>

      <!-- <van-col span="4" style="text-align: center;background: #5710B2;padding:15px 0; color:white">
        <van-icon name="home-o" size="34"  @click="addBasket(item)"/>       
      </van-col> -->

      <!-- <van-col span="8" style="text-align: center;background:#FE5E3A; color:white;  padding:15px 0">

        <van-icon name="delete-o" size="34" @click="deleteBasket(item)"/>       
      </van-col>       -->

      <van-col span="11">
        <van-dropdown-menu style="margin:8px">
          <van-dropdown-item v-model="doviz_cinsi" :options="doviz" />
          <van-dropdown-item v-model="depo" :options="depo_list" />
        </van-dropdown-menu>     
      </van-col>


    </van-row>

    <van-button v-if="varmi==0"  type="danger" size="large" style="margin-top: 25px;" @click="addVirtual(item)">LİSTEYE EKLE</van-button>
    <van-notice-bar style="margin-top:15px"  v-else text="Ürün Listede mevcut" />


    <!-- substratta virtual -->


  </van-popup>
  </div>


</template>
<script>

export default {
  props: {
    
    show: {
      type: Boolean,
      default: false,
    },
    durum : {
        type : Object,
        require : true
    },
    depolar: {
        type : Array,
        require : true
    },
    varyant: {
        type : Array,
        require : true
    },

  },
  data() {
    return {
      mesaj : '',
      activeNames :0,
      item:this.$store.getters.getStok.aktif,
      cari:this.$store.getters.getCari.aktif,
      adet:0,
      
      fiyat: { // listeden giderken sepetten gider gibi eşitlemek için yaptık
        iskonto:[], //fiyat.iskonto,  array
        liste:0, //fiyat.liste,
        kdvsiz: 0,//fiyat.kdvsiz, // iskontolardan sonraki fiyat
        kampanyali:0,// fiyat.kampanyali, // kampanya varsa liste fiyatı
        maliyet:0, //fiyat.maliyet, // sonuç maliyet kdv dahil
        kampanya:0, //fiyat.kampanya
      },
      depo:0,
      doviz_cinsi : 0,
      doviz: [
        { text: 'Döviz', value:0 },
        { text: 'Türk lirası', value:"TL" },
        { text: 'Dolar', value:"USD" },
        { text: 'Avro', value:"EUR" },
      ],    
      depo_list: [
      { text: 'Depo', value:0 },

        { text: 'Antalya', value:"Antalya" },
        { text: 'Yalova', value:"Yalova" },
      ],  
      varmi :0     
    };
  },
  created() {
    this.miktar()

   },

  methods: {
    miktar () {
      let index = this.$store.getters.getVirtual.proforma[this.cari.kod].findIndex((obj) => obj.guid == this.item.guid);
            if (index === -1) {
             this.varmi = 0
            }
            else {
              this.varmi =  this.$store.getters.getVirtual.proforma[this.cari.kod][index].adet2
            }
    },
    addBasket(obje) {
      // let obj = {
      //   obje :obje,
      //   helper : this.$helper,
      //   req : this.$request,
      //   notify:this.$notify,
      //   dialog:this.$dialog,
      // }
      this.$emit("addBasket",obje)

    },
    addVirtual(obje) {
      // let obj = {
      //   obje :obje,
      //   helper : this.$helper,
      //   req : this.$request,
      //   notify:this.$notify,
      //   dialog:this.$dialog,
      // }
      if (this.fiyat.amliyet !=0 && this.depo!= 0 && this.doviz_cinsi != 0) {
        this.$emit("addVirtual",{data:obje,doviz_cinsi:this.doviz_cinsi,depo_kod:this.depo,fiyat:this.fiyat.maliyet})
      }
      else {
        this.$notify({ type: 'danger', message: 'Alanları kontrol edin' });

      }

    },
    deleteBasket(obje){
      this.$emit("delBasket",obje)
    },
    close(){
      this.$emit("closePop")
    }

  }
};
</script>


// WEBPACK FOOTER //
// src/components/detay.vue